import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _noop from "lodash/noop";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Button from '@datacamp/waffles-button';
import { BulbIcon, CodeIcon } from '@datacamp/waffles-icons';
import React, { useCallback } from 'react';
import useShortcut from '../useShortcut';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";

var getButtonIcon = function getButtonIcon(isSolution) {
  return isSolution ? CodeIcon : BulbIcon;
};

var HintAndSolution = function HintAndSolution(_ref) {
  var _ref$borderless = _ref.borderless,
      borderless = _ref$borderless === void 0 ? false : _ref$borderless,
      _ref$isSolution = _ref.isSolution,
      isSolution = _ref$isSolution === void 0 ? false : _ref$isSolution,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? _noop : _ref$onClick,
      xp = _ref.xp;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useShortcut({
    disabled: !isVisible,
    handler: onClick,
    shortcut: {
      ctrlKey: true,
      key: 'h'
    }
  });
  var getButtonText = useCallback(function () {
    var action = isSolution ? t('HintAndSolution.showAnswer') : t('HintAndSolution.takeHint');
    var penalty = xp != null ? " (-".concat(xp, " XP)") : '';
    return "".concat(action).concat(penalty);
  }, [isSolution, xp, t]);

  if (!isVisible) {
    return null;
  }

  var ButtonIcon = getButtonIcon(isSolution);
  var buttonText = getButtonText();
  var cy = isSolution ? 'exercise-show-solution' : 'exercise-show-hint';

  var buttonStyle = _objectSpread({}, borderless && {
    border: 'none'
  });

  return ___EmotionJSX(Button, {
    className: "dc-sct-feedback__nav--hint-solution",
    css: buttonStyle,
    dataAttributes: {
      cy: cy
    },
    onClick: onClick,
    size: "small",
    tooltipPosition: "top",
    tooltipText: "Ctrl+H"
  }, ___EmotionJSX(ButtonIcon, null), buttonText);
};

export default HintAndSolution;